import { Language } from '@nxt-insurance/constants'

import { CALENDLY_STAGING_LINK } from '@flows/configs/shared/mgaLight/constants'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { SubFlow } from '@flows/insurance/types/subFlowTypes'

import { type DentalStepParams, successSchema } from './types'

const getCalendlyLink = (params: DentalStepParams) => {
  if (params.environment === 'production') {
    return params.getCurrentLanguage() === Language.De
      ? 'https://calendly.com/getsafe-leben-gesundheit/zahn'
      : 'https://calendly.com/getsafe-leben-gesundheit/dental'
  }

  return CALENDLY_STAGING_LINK
}
export const success = (params: DentalStepParams) => {
  return {
    schema: successSchema,
    stepContent: [
      {
        type: 'animation',
        width: 140,
        height: 140,
        source: require('@ui-kit/assets/animations/check.json') as string,
      },
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.title',
        },
      },
      {
        type: 'text',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.text',
        },
      },
      {
        type: 'calendly',
        title: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.title',
        },
        subtitle: {
          type: 'translatableText',
          translationKey: 'sharedFlows_common:steps.success.calendly.subtitle',
        },
        link: getCalendlyLink(params),
        bgColor: 'grey100',
      },
    ],
    subFlow: SubFlow.Common,
    onSubmit: {
      type: 'dispatchedHook',
      callbackConfig: {
        name: 'updateConsultationRequest',
        inputs: [],
        outputs: [],
      },
    },

    footer: {
      hideFooter: true,
      hideBackButton: true,
    },
    nextStep: 'appointment_details',
  } as const satisfies AnyStepConfiguration
}
